import { useTheme, useMediaQuery as useMaterialMediaQuery } from '@material-ui/core'

export const useMediaQuery = (
  size: 'xl' | 'sm' | 'md' | 'xs' | 'lg',
  direction?: 'up' | 'down'
) => {
  const theme = useTheme()
  return useMaterialMediaQuery(
    direction === 'up' ? theme.breakpoints.up(size as any) : theme.breakpoints.down(size as any)
  )
}

export default useMediaQuery
